var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};


//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/babel-polyfill/~/core-js/modules/_has.js
// module id = 4
// module chunks = 0